import React, { useState, useEffect } from "react"
import MetaTags from "react-meta-tags"
import { Link, useLocation, useHistory } from "react-router-dom"
import {
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  Label,
  Row,
  Card,
  CardImg,
  CardTitle,
  Modal,
  Collapse,
} from "reactstrap"
import "react-responsive-carousel/lib/styles/carousel.min.css"
import * as url from "helpers/url_helper"

//i18n
import PropTypes from "prop-types"
import { withTranslation } from "react-i18next"
import i18n from "i18n"

// import images
import logodark from "../../assets/images/logo-dark.png"
import logolight from "../../assets/images/logo-light.png"
import bgImage from "assets/images/ugifts/loginbg.png"
import bgProfile from "assets/images/ugifts/profile_bg.png"
import bgFriend from "assets/images/ugifts/friend_bg.png"
import inviteFriend from "assets/images/ugifts/invite_friend.png"
import iconPoint from "assets/images/ugifts/icons/profile_point.png"
import iconRibbon from "assets/images/ugifts/icon_ribbon.png"
import inviteFriendBg from "assets/images/ugifts/invite_friend_purple_bg.png"

import { Button } from "@material-ui/core"

import emptyLogin from "assets/images/ugifts/icons/empty/empty_login.png"

function useQuery() {
  return new URLSearchParams(useLocation().search)
}

const languageData = [
  { name: "English", short: "eng" },
  { name: "Chinese", short: "cn" },
  { name: "Japanese", short: "jp" },
]

const DanawaHowToConnect = props => {
  const query = useQuery()
  const history = useHistory()

  const [token, setToken] = useState(null)
  const [uid, setUid] = useState(null)
  const [basketCount, setBasketCount] = useState(null)
  const [isGuest, setIsGuest] = useState(false)

  useEffect(() => {
    if (localStorage.getItem("authUser")) {
      const obj = JSON.parse(localStorage.getItem("authUser"))
      setUid(obj.id)
      console.log(obj)
    } else {
      setIsGuest(true)
    }

    if (query.get("lang")) {
      setlanguageSelected(query.get("lang"))
    } else {
      setlanguageSelected("eng")
    }
  }, [])

  useEffect(() => {
    if (uid != null) {
      // if (!isGuest) {
        getUserProfile()
      //   getFriendList()
      //   getOrderList()
      //   getBasketData()
      //   getUdollar()
      // }
      console.log("use effect")
    }
  }, [uid])

  const [userData, setUserData] = useState(null)
  const getUserProfile = async () => {
    // var form = JSON.stringify({
    //   option: "detail_profile",
    //   id: uid,
    // })

    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "detail_profile")
    urlencoded.append("id", uid)

    const requestOptions = {
      method: "POST",
      // mode: "no-cors",
      // headers: {
      //   // "Content-Type": "application/json",
      //   Authorization: "Bearer " + token.api_token,
      // },
      body: urlencoded,
    }

    console.log("Request user profile", urlencoded)

    const response = await fetch(
      url.DANAWA_POST_MEMBER,
      // "http://47.241.176.8/api/external/auth/",
      requestOptions
    )
    const postresponse = await response.json()
    // response.body
    // setPostResponse(postresponse)
    console.log(response.status, postresponse)

    if (response.status == 200) {
      // history.push("/tables-applicationtable")
      setUserData(postresponse.data)
    } else {
      // seterror_alert(true)
    }
  }

  const [languageSelected, setlanguageSelected] = useState(false)
  const [modal_language, setmodal_language] = useState(false)
  function tog_language() {
    setmodal_language(!modal_language)
    removeBodyCss()
  }
  function removeBodyCss() {
    document.body.classList.add("no_padding")
  }

  return (
    <React.Fragment>
      <div>
        <MetaTags>
          <title>SRON | How to Connect</title>
        </MetaTags>
        <Container fluid className="p-0">
          <Row className="g-0">
            <Col
              // lg={10}
              // className="mx-auto"
              style={{
                // maxWidth: "480px",
                backgroundColor: "white",
                // backgroundImage: `url(${bgImage})`,
                // backgroundSize: "cover",
              }}
            >
              {/* <img
                src={bgImage}
                alt=""
                style={{
                  position: "absolute",
                  objectFit: "contain",
                  maxWidth: "480px",
                }}
              /> */}
              <div
                // className="auth-full-page-content"
                // className="flex"
                style={{
                  display: "flex",
                  minHeight: "100vh",
                  // paddingTop: "56px",
                  paddingBottom: "105px",
                  // background: "#EBEBEB",
                }}
              >
                <div
                  className="w-100"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    lineHeight: 1.8,
                  }}
                >
                  <div className="d-flex flex-column h-100 p-3">
                    <Row className="justify-content-center">
                      {languageSelected == "eng" && (
                        <Col xs="10">
                          <Row>
                            <Col>
                              <span className="font-size-30 font-weight-semibold">
                                {
                                  "Steps to Connect to Free Public Wi-Fi (SSID: SRDV)"
                                }
                              </span>
                            </Col>
                          </Row>
                          <hr />
                          <Row className="mb-3">
                            <Col>
                              <span className="font-size-16 font-weight-semibold">
                                {"1. Enable Wi-Fi on Your Device"}
                              </span>
                              <br />
                              <ol className="font-size-16" type="a">
                                <li>
                                  Smartphone (Android/iPhone):
                                  <ul>
                                    <li>
                                      Open <strong>Settings</strong> → Select
                                      <strong>Wi-Fi</strong>
                                    </li>
                                    <li>
                                      Toggle Wi-Fi <strong>ON</strong>
                                    </li>
                                  </ul>
                                </li>
                                <li>
                                  Laptop (Windows/Mac):
                                  <ul>
                                    <li>
                                      Click on the <strong>Wi-Fi icon</strong>{" "}
                                      in the taskbar (Windows) or menu bar (Mac)
                                    </li>
                                    <li>
                                      Turn on <strong>Wi-Fi</strong>
                                    </li>
                                  </ul>
                                </li>
                                <li>
                                  Tablet:
                                  <ul>
                                    <li>
                                      Open <strong>Settings</strong> → Select{" "}
                                      <strong>Wi-Fi</strong>
                                    </li>
                                    <li>
                                      Turn on <strong>Wi-Fi</strong>
                                    </li>
                                  </ul>
                                </li>
                              </ol>
                            </Col>
                          </Row>
                          <Row className="mb-3">
                            <Col>
                              <span className="font-size-16 font-weight-semibold">
                                {"2. Scan for Available Networks"}
                              </span>
                              <br />
                              <ol className="font-size-16" type="a">
                                <li>
                                  Your device will automatically detect nearby
                                  Wi-Fi networks.
                                </li>
                                <li>
                                  Look for the SSID (Wi-Fi network name) "SRDV"
                                  in the available networks list.
                                </li>
                              </ol>
                            </Col>
                          </Row>
                          <Row className="mb-3">
                            <Col>
                              <span className="font-size-16 font-weight-semibold">
                                {"3. Connect to the Free Wi-Fi (SRDV)"}
                              </span>
                              <br />
                              <ol className="font-size-16" type="a">
                                <li>ap or click on "SRDV" from the list.</li>
                                <li>
                                  If required, select Connect Automatically for
                                  future connections.
                                </li>
                              </ol>
                            </Col>
                          </Row>
                          <Row className="mb-3">
                            <Col>
                              <span className="font-size-16 font-weight-semibold">
                                {"4. Verify Connection"}
                              </span>
                              <br />
                              <ol className="font-size-16" type="a">
                                <li>
                                  Once logged in, you should see a Wi-Fi symbol
                                  with internet access.
                                </li>
                                <li>
                                  Open a website or app to confirm the
                                  connection.
                                </li>
                              </ol>
                            </Col>
                          </Row>
                          <Row className="mb-3">
                            <Col>
                              <span className="font-size-16 font-weight-semibold">
                                {"5. Practice Safe Browsing on Public Wi-Fi"}
                              </span>
                              <br />
                              <ul className="font-size-16">
                                <li>
                                  Avoid logging into{" "}
                                  <strong>
                                    banking apps or sensitive accounts
                                  </strong>
                                </li>
                                <li>
                                  Use a <strong>VPN</strong>, if possible, for
                                  added security
                                </li>
                                <li>
                                  Forget the network after use to prevent
                                  <strong>automatic reconnections</strong>
                                </li>
                              </ul>
                            </Col>
                          </Row>
                        </Col>
                      )}
                      {languageSelected == "bm" && (
                        <Col xs="10">
                          <Row>
                            <Col>
                              <span className="font-size-30 font-weight-semibold">
                                {
                                  "Steps to Connect to Free Public Wi-Fi (SSID: SRDV)"
                                }
                              </span>
                            </Col>
                          </Row>
                          <hr />
                          <Row className="mb-3">
                            <Col>
                              <span className="font-size-16 font-weight-semibold">
                                {"1. Enable Wi-Fi on Your Device"}
                              </span>
                              <br />
                              <ol className="font-size-16" type="a">
                                <li>
                                  Smartphone (Android/iPhone):
                                  <ul>
                                    <li>
                                      Open <strong>Settings</strong> → Select
                                      <strong>Wi-Fi</strong>
                                    </li>
                                    <li>
                                      Toggle Wi-Fi <strong>ON</strong>
                                    </li>
                                  </ul>
                                </li>
                                <li>
                                  Laptop (Windows/Mac):
                                  <ul>
                                    <li>
                                      Click on the <strong>Wi-Fi icon</strong>{" "}
                                      in the taskbar (Windows) or menu bar (Mac)
                                    </li>
                                    <li>
                                      Turn on <strong>Wi-Fi</strong>
                                    </li>
                                  </ul>
                                </li>
                                <li>
                                  Tablet:
                                  <ul>
                                    <li>
                                      Open <strong>Settings</strong> → Select{" "}
                                      <strong>Wi-Fi</strong>
                                    </li>
                                    <li>
                                      Turn on <strong>Wi-Fi</strong>
                                    </li>
                                  </ul>
                                </li>
                              </ol>
                            </Col>
                          </Row>
                          <Row className="mb-3">
                            <Col>
                              <span className="font-size-16 font-weight-semibold">
                                {"2. Scan for Available Networks"}
                              </span>
                              <br />
                              <ol className="font-size-16" type="a">
                                <li>
                                  Your device will automatically detect nearby
                                  Wi-Fi networks.
                                </li>
                                <li>
                                  Look for the SSID (Wi-Fi network name) "SRDV"
                                  in the available networks list.
                                </li>
                              </ol>
                            </Col>
                          </Row>
                          <Row className="mb-3">
                            <Col>
                              <span className="font-size-16 font-weight-semibold">
                                {"3. Connect to the Free Wi-Fi (SRDV)"}
                              </span>
                              <br />
                              <ol className="font-size-16" type="a">
                                <li>ap or click on "SRDV" from the list.</li>
                                <li>
                                  If required, select Connect Automatically for
                                  future connections.
                                </li>
                              </ol>
                            </Col>
                          </Row>
                          <Row className="mb-3">
                            <Col>
                              <span className="font-size-16 font-weight-semibold">
                                {"4. Verify Connection"}
                              </span>
                              <br />
                              <ol className="font-size-16" type="a">
                                <li>
                                  Once logged in, you should see a Wi-Fi symbol
                                  with internet access.
                                </li>
                                <li>
                                  Open a website or app to confirm the
                                  connection.
                                </li>
                              </ol>
                            </Col>
                          </Row>
                          <Row className="mb-3">
                            <Col>
                              <span className="font-size-16 font-weight-semibold">
                                {"5. Practice Safe Browsing on Public Wi-Fi"}
                              </span>
                              <br />
                              <ul className="font-size-16">
                                <li>
                                  Avoid logging into{" "}
                                  <strong>
                                    banking apps or sensitive accounts
                                  </strong>
                                </li>
                                <li>
                                  Use a <strong>VPN</strong>, if possible, for
                                  added security
                                </li>
                                <li>
                                  Forget the network after use to prevent
                                  <strong>automatic reconnections</strong>
                                </li>
                              </ul>
                            </Col>
                          </Row>
                        </Col>
                      )}
                    </Row>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withTranslation()(DanawaHowToConnect)

DanawaHowToConnect.propTypes = {
  t: PropTypes.any,
}
